import { useEffect } from "react";
import FieldHeader from "../FieldHeader";

function Checkbox({ parameters, value, onChange }) {
  useEffect(() => {
    if (parameters.default) {
      onChange(parameters.default);
    }
  }, []);

  return (
    <div>
      <FieldHeader
        label={parameters.label}
        description={parameters.description}
      />
      <input
        style={{
          display: "flex",
          cursor: "pointer",
          width: "20px",
          height: "20px",
        }}
        type="checkbox"
        checked={value}
        onChange={(e) => onChange(e.target.checked)}
      />
    </div>
  );
}

export default Checkbox;
